import Component from 'gia/Component'
import _each from 'lodash.foreach'
import gsap from 'gsap'
import stage from '../components/stage'
import {
  ScrollTrigger
} from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);
import Observer from '../components/observer';

class Cover extends Component {

  constructor(element) {

    super(element)



    this.element = element
    this.el = $(element)
    this.index = 0
    this.current = 0

    this.decos = []
    this.imgs = []


    this.ref = {
      
      img: [],
      cover: null

    }

  }

  mount() {

   

    // this.observer = new Observer({
    //   rootMargin: '-90% 0% 0% 0%',
    //   callback: this.callback.bind(this)
    // });
    // this.observer.add('.cover');

    if( !document.body.classList.contains("menuinit")){
      document.body.classList.add('hidemenu')
    }
    

     lenis.on('scroll', (e)=>{
       if(e.animatedScroll > 10){
        document.body.classList.remove('hidemenu')
       } 
     })

    _each(this.ref.img, (item, i) => {
      const imga = gsap.to(item, {
        yPercent: -item.dataset.offset*2 ,
        scrollTrigger: {
          trigger: this.ref.cover,
          start: "top top",
          end: "bottom top",
          scrub: 1
        }
      })

      this.imgs.push(imga)
    })


  }

  callback(e){
    console.log(e);
    document.body.classList.toggle('hidemenu', e)
  }

  




  resize() {

  }

  unmount() {

    // this.observer.disconnect()


    _each(this.imgs, (item, index) => {
      item.kill();
    })


  }


}

module.exports = Cover